module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-1.72d231e4.mp3";